export default __webpack_public_path__ + "static/media/arrowdownheader.496bb694.svg";